export function handleResultadosGeraisStrategy(plotData, viewConfigData, order) {
  if (!viewConfigData.graficos[0].checked) {
    return null;
  }

  const newData = {
    ...plotData,
    renderType: viewConfigData.graficos[0].render,
    renderOrder: order
  };

  return newData;
}
